import React from 'react';
import PropTypes from 'prop-types';
import MainTitle from 'base/components/MainTitle/index';
import { closeModal } from 'modal/store/actions';
import { useCreateContactMutation } from 'contacts/store/contactService';
import { useAppDispatch } from 'store/hooks';
import toast from 'base/components/Toast/toast';
import ContactForm from './ContactForm';

export default function CreateContactModal({ name, contact = {} }) {
  const dispatch = useAppDispatch();
  const [createContact] = useCreateContactMutation();
  return (
    <>
      <MainTitle withSpaceBelow>New Contact</MainTitle>

      <ContactForm
        contact={contact}
        isAdminForm
        onSubmit={async contact => {
          try {
            await createContact({ contact, image: contact?.imageFile[0]?.fileObject || null }).unwrap();
            toast.success('Successfully created contact');
            dispatch(closeModal(name));
          } catch (error) {
            toast.error('Error creating contact');
          }
        }}
      />
    </>
  );
}
CreateContactModal.propTypes = {
  name: PropTypes.string.isRequired,
  contact: PropTypes.objectOf(PropTypes.any),
};
CreateContactModal.defaultProps = {
  contact: {},
};
